module.exports = __webpack_public_path__ + "static/media/hairSprayPreto.38f48835.png";